import '../js/app'
import '../js/sharedfilelist'

// eslint-disable-next-line camelcase
__webpack_nonce__ = btoa(OC.requestToken)
// eslint-disable-next-line camelcase
__webpack_public_path__ = OC.linkTo('files_sharing', 'js/dist/')
